import { InspectionDocument } from '../Inspections/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { InspectionSeverityDocument, inspectionSeverityPullQueryBuilder } from './queryBuilder';

export function inspectionSeverityFamilyMember(
  configBuilder: ConfigBuilder,
  inspections: FamilyMember<InspectionDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<InspectionSeverityDocument> {
  const syncConfig = configBuilder<InspectionSeverityDocument>(
    RxdbCollectionNameV2.INSPECTION_SEVERITY,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, inspectionSeverityPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.INSPECTION_SEVERITY, replicationState, [inspections, sites]);
}
